/* eslint import/no-webpack-loader-syntax: off */

//@ts-ignore
import mapboxgl from '!mapbox-gl';
import { useContext, useRef, useEffect } from 'react';
import { PlacesContext, MapContext } from "../context"
import { Loading } from "./";


export const MapView = () => {

  const { isLoading, userLocation } = useContext(PlacesContext);
  const { setMap } = useContext(MapContext);
  const mapDiv = useRef<HTMLDivElement>(null);

  useEffect(() => {

    if(isLoading) return;

    const map = new mapboxgl.Map({
      container: mapDiv.current!, // container ID
      style: 'mapbox://styles/mapbox/dark-v10', // style URL
      center: userLocation, // starting position [lng, lat]
      zoom: 14, // starting zoom
      // projection: 'marcator' // display the map as a 3D globe
    });

    setMap( map );
  }, [ isLoading ])
  

  if( isLoading ) return <Loading />

  return (
    <div 
      ref={ mapDiv }
      className="mapdiv"
    >
      { userLocation?.join(',') }
    </div>
  )
}
